.kf{min-width:14rem;}